import { render, staticRenderFns } from "./qs4-07.vue?vue&type=template&id=c45736be&scoped=true&"
import script from "./qs4-07.vue?vue&type=script&lang=js&"
export * from "./qs4-07.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c45736be",
  null
  
)

export default component.exports